export type MinMax = { min: number, max: number }

export const normalizeBetweenRange = (value: number = 50, output: MinMax = {min: 0, max:1}, input:MinMax = {min: 0, max: 100},):number => {
  const target = (((value - input.min) / (input.max - input.min)))*(output.max - output.min) + output.min
  return target
}

const defaultRGB = { r: 0, g: 0, b: 0 }

export const updateInterpolatedColor = ( factor: number, startColor: string = '#FFA300', endColor: string = '#FFFFFF') => {
  // src: https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
  const c1 = hexToRgb(startColor) || defaultRGB
  const c2 = hexToRgb(endColor) || defaultRGB

  const r = Math.round(c1.r + factor * (c2.r - c1.r))
  const g = Math.round(c1.g + factor * (c2.g - c1.g))
  const b = Math.round(c1.b + factor * (c2.b - c1.b))

  const interpolatedColor = rgbToHex(r, g, b)
  return interpolatedColor
}

const hexToRgb = (hex: string) => {
  const rawHex = hex.replace('#', '')
  return rawHex ? {
    r: parseInt(rawHex.substring(0, 1), 16),
    g: parseInt(rawHex.substring(2, 3), 16),
    b: parseInt(rawHex.substring(4, 5), 16)
  } : defaultRGB
}

const rgbToHex = (r: number, g: number, b: number) => {
  return `#${[r, g, b].map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? '0' + hex : hex
  }).join('')}`
}

export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
